const Unauthorized = () => (
    <div style={{ padding: '2rem', color: 'red' }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
  
  export default Unauthorized;
  